<template>
  <v-card flat>
    <v-card-title class="justify-center mb-5">{{ $t('adminVideo.title') }}</v-card-title>
    <v-card-subtitle class="text-center text-secondary">{{ $t('adminVideo.subtitle') }}</v-card-subtitle>
  </v-card>
</template>

<script>
export default {
  name: 'AdminViewTitle'
}
</script>
